/** Niveau régional affiché dans le badge (R1, R2, R3). */
function isRegionalLevel(value: string): boolean {
  return /^r[123]$/i.test(value.trim());
}

/** Nom de poule à exclure du badge (C, A, « Poule C », etc.). */
function isPouleGroupLabel(value: string): boolean {
  const s = value.trim();
  if (!s) return false;
  if (isRegionalLevel(s)) return false;
  if (/^poule\s+/i.test(s)) return true;
  // Lettre ou libellé court de poule (ex. C, A, B)
  if (/^[A-Za-zÀ-ÿ]{1,3}$/.test(s)) return true;
  return false;
}

function extractRegionalFromCompetition(competition: string): {
  category: string;
  regional?: string;
} {
  let category = competition.trim();
  let regional: string | undefined;

  const embedded = category.match(/\s+(R[123])\b/i);
  if (embedded) {
    regional = embedded[1].toUpperCase();
    category = category.replace(/\s+R[123]\b/i, '').trim();
  }

  category = category.replace(/\s*-\s*Poule\s+.+$/i, '').trim();

  return { category, regional };
}

function regionalFromPouleField(poule?: string): string | undefined {
  const raw = (poule ?? '').trim();
  if (!raw) return undefined;
  const withoutPrefix = raw.replace(/^poule\s+/i, '').trim();
  if (isRegionalLevel(withoutPrefix)) return withoutPrefix.toUpperCase();
  if (isPouleGroupLabel(withoutPrefix)) return undefined;
  // Valeur inconnue : on ne l’affiche pas (évite « Poule C »)
  return undefined;
}

/**
 * Badge catégorie : « U16 R3 » (catégorie + niveau régional).
 * Exclut la poule au sens FFF (ex. « Poule C », lettre C).
 */
export function formatObservationCategoryBadge(
  competition?: string,
  poule?: string,
): string | undefined {
  const comp = (competition ?? '').trim();
  const { category, regional: regionalFromComp } = comp
    ? extractRegionalFromCompetition(comp)
    : { category: '', regional: undefined };

  const regional = regionalFromComp ?? regionalFromPouleField(poule);
  const cat = category.trim();

  if (!cat && !regional) return undefined;
  if (!cat) return regional;
  if (!regional) return cat;

  const catLower = cat.toLowerCase();
  if (catLower === regional.toLowerCase() || catLower.endsWith(` ${regional.toLowerCase()}`)) {
    return cat;
  }

  return `${cat} ${regional}`;
}

export function getObservationCategoryBadge(obs: {
  matchCompetition?: string;
  matchPoule?: string;
}): string | undefined {
  return formatObservationCategoryBadge(obs.matchCompetition, obs.matchPoule);
}
